import React from 'react';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const CustomOption = (props) => {
  const {
    innerProps,
    isDisabled,
    isFocused,
    isSelected,
    label,
    value,
    data: { __isNew__: isCreateOption, level },
  } = props;

  return !isDisabled ? (
    <div
      {...innerProps}
      className={`ct-option ${isFocused ? 'focused' : ''}`}
      data-e2e={isCreateOption ? 'create-option' : 'ct-option'}
      key={value}
    >
      <span
        style={
          level && {
            marginLeft: level * 10,
          }
        }
        className={isSelected ? 'selected' : null}
      >
        {label}
      </span>

      {isSelected && <FontAwesomeIcon className="option-icon" icon={faCheck} />}
    </div>
  ) : null;
};
